import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    components:{
        Header: ()=> import('@/components/header/index.vue'),
        leftBar: ()=> import('@/components/left-bar/index.vue'),
        TableOptions: ()=> import('@/components/table/options/index.vue'),
        Table: ()=> import('@/components/table/list/index.vue'),
    },
    data(){
       return{
           // Статичні визначення полів: перекладні підписи — labelKey,
           // сам `label` обчислюється в computed fields (залежить від локалі).
           fieldDefs:[
               {
                   key:'id',
                   label:'№',
               },
               {
                   key:'register_number',
                   labelKey:'npRegisters.number',
               },
               {
                   key:'register_count',
                   labelKey:'npRegisters.count',
               },
               {
                   key:'register_created',
                   labelKey:'npRegisters.created',
               },
               {
                   key:'register_dop',
                   labelKey:'npRegisters.extra',
               },
               {
                   key:'register_ref',
                   label:'Ref',
               },
               {
                   key:'register_printed',
                   labelKey:'npRegisters.status',
               },
               {
                   key:'register_print',
                   labelKey:'npRegisters.print',
               },
           ],
           items:[],
           npCounterparties: [],
       }
    },
    computed:{
      fields() {
          return this.fieldDefs.map(field => field.labelKey
              ? { ...field, label: this.$t(field.labelKey) }
              : field);
      },
      ...mapGetters({
          registryList:'npRegistry/registryList',
          options:'config/options',
          npCounterpartiesList: 'npAutomation/npCounterparties',
      }),
      defaultApiKey() {
          // Використовуємо API-ключ контрагента за замовчуванням (бэкенд
          // розв'язує його через db_counterparty_id), сам ключ тут недоступний
          const defaultCounterparty = this.npCounterparties.find(cp => cp.is_default === true);
          if (defaultCounterparty && defaultCounterparty.id) {
              // Повертаємо null: використовуватимемо db_counterparty_id
              return null;
          }
          // No fallback - require default counterparty
          return null;
      },
      defaultCounterpartyId() {
          const defaultCounterparty = this.npCounterparties.find(cp => cp.is_default === true);
          return defaultCounterparty?.id || null;
      },
    },
    watch:{
        registryList(e){
            // Require default counterparty - no fallback to global API key
            if (!this.defaultCounterpartyId) {
                const errorMsg = this.$t('toasts.err_default_counterparty');
                if (this.$toasted) {
                    this.$toasted.error(errorMsg, { duration: 5000 });
                }
                console.error('No default counterparty found in database for register printing');
                this.items = [];
                return;
            }
            
            this.items = [];
            let i = 0;
            e.models.map(item=>{
                i++
                this.items.push({
                    id:i,
                    register_number: item.Number,
                    register_count: item.Count,
                    register_created: item.DateTime,
                    register_dop: item.Description,
                    register_ref: item.Ref,
                    register_printed: item.Printed,
                    register_print: {
                        ref: item.Ref, 
                        key: null, // Not used when printing via backend
                        db_counterparty_id: this.defaultCounterpartyId // Backend will use this to get counterparty's API key
                    }
                })
            });
        },
        npCounterpartiesList(data) {
            if (data && Array.isArray(data)) {
                this.npCounterparties = data;
            }
        },
    },
    created() {
        this.toggleLoadingStatus(true);
        // Load counterparties first to get default counterparty
        this.getNpCounterparties().then(() => {
            this.getOptions().then(()=>{
                if (!this.defaultCounterpartyId) {
                    this.toggleLoadingStatus(false);
                    const errorMsg = this.$t('toasts.err_default_counterparty');
                    this.$toasted?.error(errorMsg, { duration: 5000 });
                    return;
                }
                this.getRegistryList({ db_counterparty_id: this.defaultCounterpartyId }).then(()=>{
                    this.toggleLoadingStatus(false);
                })
            });
        }).catch(() => {
            // If counterparties fail to load, show error
            this.toggleLoadingStatus(false);
            const errorMsg = this.$t('toasts.err_load_counterparties');
            if (this.$toasted) {
                this.$toasted.error(errorMsg, { duration: 5000 });
            }
            console.error('Failed to load counterparties for registers');
        });
    },
    methods:{
        editClickItem(){
        },
        removeItem(){
        },
        ...mapActions({
            getRegistryList:'npRegistry/getRegistryList',
            getOptions:'config/getOptions',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        }),
    }
}
